import { useCallback, useState } from 'react'
import { trackEmailCaptured } from '@mc/pre-paywall-events'
import { getPageSource } from '@mc/track-event'

export type EmailCaptureTrackProps = {
  campaign?: string
  location?: string
  contentType?: string
  slug?: string
  category?: string
}

export const useEmailCaptureSubmit = (trackProps?: EmailCaptureTrackProps) => {
  const [success, setSuccess] = useState(false)

  const handleSubmit = useCallback(
    async ({ email }: { email: string }) => {
      await trackEmailCaptured({
        event: 'Email Captured',
        properties: {
          campaign: trackProps?.campaign || 'sample',
          email,
          location: trackProps?.location,
          content_type: trackProps?.contentType,
          slug: trackProps?.slug,
          type: 'email',
          platform: 'web',
          category: trackProps?.category,
          page_source: getPageSource(),
        },
        integrations: { Iterable: true },
      })
      setSuccess(true)
    },
    [trackProps],
  )

  return { success, handleSubmit }
}
